import { Link, useRouteError } from 'react-router-dom';

export function NotFound(): JSX.Element {
  const err = useRouteError() as { status?: number; statusText?: string } | undefined;
  const code = err?.status ?? 404;
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="text-6xl font-bold text-slate-300">{code}</div>
        <h1 className="mt-2 text-xl font-semibold">Página no encontrada</h1>
        <p className="mt-2 text-sm text-slate-500">
          {err?.statusText ?? 'La ruta solicitada no existe o fue eliminada.'}
        </p>
        <Link
          to="/"
          className="mt-4 inline-block rounded bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
